import AdminUsers from 'components/admins';
const Admins = () => {
  return <AdminUsers />;
};

export default Admins;
